import i18n from "i18next";
import moment from "moment";
import { api } from "common";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "./components/CircularLoading";

function AuthLoading(props: any) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const languagedata = useSelector((state) => state.languagedata);
  const settingsdata = useSelector((state) => state.settingsdata);
  const {
    signOff,
    fetchCars,
    fetchUser,
    fetchPanic,
    fetchPlans,
    fetchUsers,
    fetchPromos,
    fetchBanners,
    fetchCarTypes,
    fetchSettings,
    fetchBookings,
    fetchLanguages,
    fetchWithdraws,
    fetchCancelReasons,
    fetchWalletHistory,
    fetchNotifications,
    fetchDriverEarnings,
    fetchEarningsReport,
    fetchAdmSavedAddresses,
  } = api;


  useEffect(() => {
    dispatch(fetchSettings());
  }, [dispatch, fetchSettings]);

  useEffect(() => {
    if (languagedata.langlist) {
      for (const value of Object.values(languagedata.langlist)) {
        if (value.default === true) {
          i18n.addResourceBundle(
            value.langLocale,
            "translations",
            value.keyValuePairs
          );
          i18n.changeLanguage(value.langLocale);
          moment.locale(value.dateLocale);
        }
      }
      dispatch(fetchUser());
    }
  }, [languagedata, dispatch, fetchUser]);

  useEffect(() => {
    if (settingsdata.settings) {
      dispatch(fetchLanguages());
      dispatch(fetchCarTypes());
      document.title = settingsdata.settings.appName;
    }
  }, [settingsdata.settings, dispatch, fetchLanguages, fetchCarTypes]);

  useEffect(() => {
    if (auth.profile) {
      if (auth.profile.usertype) {
        let role = auth.profile.usertype;
        if (role === "admin") {
          dispatch(fetchUsers());
          dispatch(fetchCars());
          dispatch(fetchPanic());
          dispatch(fetchPromos());
          dispatch(fetchBookings());
          dispatch(fetchWithdraws());
          dispatch(fetchCancelReasons());
          dispatch(fetchNotifications());
          dispatch(fetchDriverEarnings({ t, period: "monthly" }));
          dispatch(fetchEarningsReport({ t, period: "monthly" }));
          if (settingsdata.settings?.REACT_APP_PAGOPAR_PLANS_ACTIVE === true) dispatch(fetchPlans())
          if (settingsdata.settings?.premiumFeatures?.REACT_APP_BANNERS === true) dispatch(fetchBanners())
          if (settingsdata.settings?.premiumFeatures?.REACT_APP_ADM_SAVED_ADDRESSES === true) dispatch(fetchAdmSavedAddresses());
        } else if (role === "fleetadmin") {
          dispatch(fetchCars());
          dispatch(fetchUsers());
          dispatch(fetchBookings());
          dispatch(fetchCancelReasons());
          dispatch(fetchDriverEarnings({ t, period: "monthly", fleetAdminId: auth.profile.id }));
        } else {
          alert(t("not_valid_user_type"));
          dispatch(signOff());
        }
      } else {
        alert(t("user_issue_contact_admin"));
        dispatch(signOff());
      }
    }
  }, [
    t,
    signOff,
    dispatch,
    fetchCars,
    fetchUsers,
    fetchPlans,
    fetchPromos,
    fetchBanners,
    auth.profile,
    fetchBookings,
    fetchWithdraws,
    fetchCancelReasons,
    fetchNotifications,
    fetchWalletHistory,
    fetchDriverEarnings,
    fetchEarningsReport,
    fetchAdmSavedAddresses,
  ]);

  return settingsdata.loading ? (
    <CircularLoading />
  ) : settingsdata.settings ? (
    auth.loading || !languagedata.langlist ? (
      <CircularLoading />
    ) : (
      props.children
    )
  ) : (
    <div>
      <CircularLoading />
    </div>
  );
}

export default AuthLoading;
